import React from 'react'
import styled from 'styled-components'

const StyledLink = styled.a`
    margin-bottom: 10px;
    margin-right: 15px;
    font-size: 1.1em;
    display: inline-block;
`

function Projects({ content }) {
    const { projects } = content;
    return (
        <div>
            <h2>Projects</h2>
            {
                projects.map((project, idx) => (
                    <div key={idx}>
                        <h3>{project.title}</h3>
                        <p>{project.description}</p>
                        {
                            project.myRole &&
                            <p><strong>My role:</strong> {project.myRole}</p>
                        }
                        <p><strong>Tech Stack:</strong> {project.techStack}</p>
                        <div style={{ marginTop: '8px', marginBottom: '10px' }}>
                            {
                                project.url &&
                                <StyledLink href={project.url} target="_blank" rel="noopener noreferrer">
                                    {project.appStoreUrl || project.playStoreUrl ? (
                                        <><span role="img" aria-label="web">🌐</span> Web Sitesi</>
                                    ) : 'Link'}
                                </StyledLink>
                            }
                            {
                                project.appStoreUrl &&
                                <StyledLink href={project.appStoreUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#000080', fontWeight: 'bold' }}>
                                    <span role="img" aria-label="apple">🍏</span> App Store (iOS)
                                </StyledLink>
                            }
                            {
                                project.playStoreUrl &&
                                <StyledLink href={project.playStoreUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#006600', fontWeight: 'bold' }}>
                                    <span role="img" aria-label="android">🤖</span> Google Play (Android)
                                </StyledLink>
                            }
                            {
                                project.repo &&
                                <StyledLink href={project.repo} target="_blank" rel="noopener noreferrer">GitHub Repo</StyledLink>
                            }
                        </div>
                        <hr />
                    </div>
                ))
            }

        </div>
    )
}

export default Projects
